import {get} from '../utils'

export default host => () =>
  get(`${host}/clients?has_license=true&order_by=name`)
    .then(response => response.json())
    .then(json => json.data)